<mcg-window #formWindow [actions]="actions" (actionButtonClicked)="actionButtonClicked($event)"
  [title]="translate('Ficha_ciudadano') + ': ' + ciudadano?.nombre + ' ' + ciudadano?.apellidos"
  (windowClose)="onClose()">
  <jqxRibbon #ciudRibbon [theme]="environment.tema" [position]="'top'" [height]="'100%'"
    (onSelect)="tabSelected($event)">
    <ul style="width: 100%; text-align: left; z-index: 99; background-color: rgb(225, 229, 231);">
      <li>
        {{ translate('Informacion') }}
      </li>
      <li>
        {{ translate('Direcciones') }}
      </li>
      <li>
        {{ translate('Tarjetas') }}
      </li>
    </ul>

    <div>
      <!-- PESTAÑA DEL FORMULARIO -->
      <div style="background-color: transparent; padding: 0%; overflow-y: auto;">
        <div style="display: inline-table !important; width: 100%; height: 100%;">
          <div #fieldsetPersonal id="fieldsetPersonal">
            <fieldset>
              <legend>{{ translate('Personal_contacto') }}</legend>

              <div class="row">
                <span style="width: 20%;" *ngIf="camposLopd['nombre']?.visible">
                  <div style="clear: both">
                    {{ translate('Nombre') }}
                    <span *ngIf="camposLopd['nombre']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['nombre']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.nombre" (ngModelChange)="ciudadano.nombre = $event"
                    [width]="'100%'">
                  </jqxInput>
                </span>

                <span style="width: 30%;" *ngIf="camposLopd['apellidos']?.visible">
                  <div style="clear: both">
                    {{ translate('Apellidos') }}
                    <span *ngIf="camposLopd['apellidos']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['apellidos']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.apellidos" (ngModelChange)="ciudadano.apellidos = $event"
                    [width]="'100%'">
                  </jqxInput>
                </span>

                <span style="width: 20%;" *ngIf="camposLopd['nif']?.visible">
                  <div style="clear: both">
                    {{ translate('Dni') }}
                    <span *ngIf="ciudadanoService?.getDniExists()" style="color: #d40c0c;">{{ translate('DNI_existe') }}</span>
                    <span *ngIf="camposLopd['nif']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="!dniFormatoValido" style="color: red;">{{translate('Dni_no_valido')}}</span>
                    <span *ngIf="camposLopd['nif']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.nif" (ngModelChange)="ciudadano.nif = $event" [width]="'100%'">
                  </jqxInput>
                </span>

                <span style="width: 15%;">
                  <div style="clear: both">
                    {{ translate('Estado') }}
                  </div>
                  <jqxDropDownList #dropValidado [source]="source" (onChange)="changeValidado($event)"
                    style="float: left" [width]="'100%'" [dropDownHeight]="30*source?.length">
                  </jqxDropDownList>
                </span>

                <span *ngIf="ecoIdentificadores" style="width: 7%;">
                  <div style="clear: both">
                    {{ translate('Num_tarjetas') }}
                  </div>
                  <jqxInput [value]="ciudadano?.tarjetas ? ciudadano?.tarjetas?.length : 0" [rtl]="true"
                    [width]="'60%'" disabled="true">
                  </jqxInput>
                </span>

                <span style="width: 20%;" *ngIf="camposLopd['telefono']?.visible">
                  <div style="clear: both">
                    {{ translate('Telefono') }}
                    <span *ngIf="camposLopd['telefono']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['telefono']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.telefono" (ngModelChange)="ciudadano.telefono = $event" [rtl]="true"
                    [width]="'100%'">
                  </jqxInput>
                </span>

                <span style="width: 30%;" *ngIf="camposLopd['correoElectronico']?.visible">
                  <div style="clear: both">
                    {{ translate('Correo_electronico') }}
                    <span *ngIf="ciudadanoEmailExist" style="color: #d40c0c;">{{translate('Correo_existe')}}</span>

                    <span *ngIf="camposLopd['correoElectronico']?.obligatorio"
                      style="color: red;">(*)</span>
                      <span *ngIf="!emailFormatoValido" style="color: red;">{{translate('Correo_electronico_no_valido')}}</span>
                    <span *ngIf="camposLopd['correoElectronico']?.personal"
                      style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.correoElectronico"
                    (ngModelChange)="ciudadano.correoElectronico = $event" [width]="'100%'"
                    (onChange)="checkCiudadano($event)">
                  </jqxInput>
                </span>

                <span *ngIf="ecoCompostaje" style="width: 25%;">
                  <div style="margin-top: 5px; clear: both">
                    Tipo
                  </div>
                  <jqxInput [ngModel]="ciudadano?.tipo" (ngModelChange)="ciudadano.tipo = $event" [width]="'100%'"
                    disabled="true">
                  </jqxInput>
                </span>

              </div>

              <!-- <div class="row">

              </div> -->
            </fieldset>
          </div>

          <div #fieldsetDireccion id="fieldsetDireccion">
            <fieldset>
              <legend>{{ translate('Direccion_principal') }}</legend>

              <h3>{{ translate('Direccion_cartografica') }}</h3>

              <div class="row" *ngIf="camposLopd['direccion']?.visible">
                <span style="width: 25%;">
                  <div style="clear: both">
                    {{ translate('Buscar') }}
                  </div>
                  <span #mapSearch style="height: 25px;">
                    <movisat-map-search style="float: left; width: calc(100% - 30px); height: 25px;"
                      (mapSearch)="onMapSearch($event)">
                    </movisat-map-search>
                    <jqxButton class="button" style="float: left; margin-left: 5px; cursor: pointer;
                      display: flex; align-items: center; justify-content: center;" [width]="25" [height]="25"
                      [title]="translate('Selecciona_una_ubicacion')" (onClick)="onPosicionar()">
                      <img src="/assets/images/posicion.png" style="height: 20px; width: 20px;">
                    </jqxButton>
                  </span>
                </span>

                <span style="width: 28%;" *ngIf="camposLopd['direccion']?.visible">
                  <div style="clear: both">
                    {{ translate('Domicilio') }}
                    <span *ngIf="camposLopd['direccion']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['direccion']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [value]="ciudadano?.direccion" [width]="'100%'" [disabled]="true">
                  </jqxInput>
                </span>

                <span *ngIf="camposLopd['numero']?.visible" style="width: 28%;">
                  <div style="clear: both">
                    {{ 'Número' }}
                    <span *ngIf="camposLopd['numero']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['numero']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [value]="ciudadano?.numero" [width]="'100%'" [disabled]="true"></jqxInput>
                </span>

                <span *ngIf="camposLopd['codigoPostal']?.visible">
                  <div style="clear: both">
                    {{ translate('Codigo_postal') }}
                    <span *ngIf="camposLopd['codigoPostal']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['codigoPostal']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [value]="ciudadano?.codigoPostal" [rtl]="true" [width]="'55%'" [disabled]="true">
                  </jqxInput>
                </span>

                <span style="width: 5%;" *ngIf="camposLopd['planta']?.visible">
                  <div style="clear: both">
                    {{ translate('Planta') }}
                    <span *ngIf="camposLopd['planta']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['planta']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.planta" (ngModelChange)="ciudadano.planta = $event" [rtl]="true"
                    [width]="'100%'">
                  </jqxInput>
                </span>

                <span style="width: 5%;" *ngIf="camposLopd['puerta']?.visible">
                  <div style="clear: both">
                    {{ translate('Puerta') }}
                    <span *ngIf="camposLopd['puerta']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['puerta']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.puerta" (ngModelChange)="ciudadano.puerta = $event" [rtl]="true"
                    [width]="'100%'">
                  </jqxInput>
                </span>

                <span style="width: 22%;" *ngIf="camposLopd['poblacion']?.visible">
                  <div style="clear: both">
                    {{ translate('Poblacion') }}
                    <span *ngIf="camposLopd['poblacion']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['poblacion']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [value]="ciudadano?.poblacion" [width]="'100%'" [disabled]="true">
                  </jqxInput>
                </span>

                <span style="width: 25%;" *ngIf="camposLopd['municipio']?.visible">
                  <div style="clear: both">
                    {{ translate('Municipio') }}
                    <span *ngIf="camposLopd['municipio']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['municipio']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [value]="ciudadano?.municipio" [width]="'100%'" [disabled]="true">
                  </jqxInput>
                </span>

                <span style="width: 25%;" *ngIf="camposLopd['provincia']?.visible">
                  <div style="clear: both;">
                    {{ translate('Provincia') }}
                    <span *ngIf="camposLopd['provincia']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['provincia']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [value]="ciudadano?.provincia" [width]="'100%'" [disabled]="true">
                  </jqxInput>
                </span>

                <span style="width: 25%;" *ngIf="camposLopd['comunidadAutonoma']?.visible">
                  <div style="clear: both;">
                    {{ translate('Comunidad_autonoma') }}
                    <span *ngIf="camposLopd['comunidadAutonoma']?.obligatorio"
                      style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['comunidadAutonoma']?.personal"
                      style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [value]="ciudadano?.comunidadAutonoma" [width]="'100%'" [disabled]="true">
                  </jqxInput>
                </span>

                <span style="width: 8%;" *ngIf="camposLopd['numeroAbonado']?.visible">
                  <div style="clear: both;">
                    {{ translate('Num_abonado') }}
                    <span *ngIf="camposLopd['numeroAbonado']?.obligatorio" style="color: red;">(*)</span>
                    <span *ngIf="camposLopd['numeroAbonado']?.personal" style="color: blue;">(DP)</span>
                  </div>
                  <jqxInput [ngModel]="ciudadano?.numeroAbonado" (ngModelChange)="ciudadano.numeroAbonado = $event"
                    [width]="'100%'" [disabled]="false">
                  </jqxInput>
                </span>
              </div>
              <!-- <div class="row">

              </div> -->
              <div *ngIf="camposLopd['numeroCatastro']?.visible">
                <h3>{{ translate('Catastro') }}</h3>
                <app-selector-catastro #selectorCatastro [ciudadano]="ciudadano"
                  [camposVisibles]="camposLopd"></app-selector-catastro>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <!-- PESTAÑA DEL LISTADO DE DIRECCIONES -->
      <div style="background-color: transparent; padding: 0%; overflow-y: hidden !important;">
        <app-direccion-listado #ciudadanoDirecciones [ciudadano]="ciudadano"
          (outputDireccion)="asignarDireccion($event)"></app-direccion-listado>
      </div>

      <!-- PESTAÑA DE ASIGNACION DE TARJETAS -->
      <div style="background-color: transparent; padding: 0%; overflow-y: hidden !important;">
        <app-ciudadanos-tarjetas #ciudadanoTarjetas [ciudadano]="ciudadano"
          [inputDireccion]="direccion"></app-ciudadanos-tarjetas>
      </div>
    </div>
  </jqxRibbon>
</mcg-window>

<div class="loader-container" *ngIf="showLoader">
  <div class="loader"></div>
</div>
